// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  $center?: boolean,
  children: React.Node,
}

const TitleWrapper: React.ComponentType<Props> = tw.div`
  mb-4
  lg:mb-0
  md:w-full
  lg:w-1/2

  ${(props: Props) =>
    props.$center &&
    `
    text-center
    sm:w-full
    md:w-full
    lg:w-full
  `}
`

export default TitleWrapper
